// Simulasi gerak Alun-alun di klien — cermin dari alun_layout.posisi_pada di server (jalur + t0 + kecepatan tetap),
// sehingga semua klien melihat posisi yang sama tanpa mengirim koordinat tiap frame.

// Mengembalikan posisi dunia + arah gerak satuan (dx, dy) agar renderer bisa menentukan hadap sprite relatif kamera.
export function posisiPemain(p, now, kecepatan) {
  const j = p.jalur || [[p.x, p.y]];
  if (j.length <= 1) return { x: j[0][0], y: j[0][1], bergerak: false, dx: 0, dy: 0 };
  let d = Math.max(0, (now - p.t0) / 1000) * kecepatan;
  for (let i = 0; i < j.length - 1; i++) {
    const [ax, ay] = j[i], [bx, by] = j[i + 1];
    const seg = Math.hypot(bx - ax, by - ay);
    if (d <= seg) {
      const k = seg ? d / seg : 1;
      return { x: ax + (bx - ax) * k, y: ay + (by - ay) * k, bergerak: true, dx: seg ? (bx - ax) / seg : 0, dy: seg ? (by - ay) / seg : 0 };
    }
    d -= seg;
  }
  const [lx, ly] = j[j.length - 1];
  return { x: lx, y: ly, bergerak: false, dx: 0, dy: 0 };
}

export const jarak = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

// Jumlah pemain lain dalam radius dekat dari pemain `me`
export function hitungDekat(players, meId, now, layout) {
  const me = players.get(meId);
  if (!me || !layout) return 0;
  const pm = posisiPemain(me, now, layout.kecepatan);
  let n = 0;
  for (const p of players.values()) {
    if (p.id === meId) continue;
    if (jarak(pm, posisiPemain(p, now, layout.kecepatan)) <= layout.radius_dekat) n++;
  }
  return n;
}
